// TODO: translations
import React from "react";

import { useIntl } from "react-intl";
import styled from "styled-components";

import {
  CarbonEmissionsGraph,
  CarbonEmissionsGraphProps
} from "./carbonEmissionsGraph";
import { CHART_CONFIG } from "./carbonEmissionsGraph.config";
import { Popover } from "./Popover";

interface GraphSectionProps {
  graphData: CarbonEmissionsGraphProps["chartData"];
  year: number;
  total: number;
}

export const GraphSection: React.FC<GraphSectionProps> = ({
  graphData,
  year,
  total
}) => {
  const intl = useIntl();

  return (
    <>
      <EmissionsHeader>
        <Flex>
          <EmissionsTitle>
            {intl.formatMessage(
              {
                id: "carbon.emissions.graph.title"
              },
              {
                year
              }
            )}
          </EmissionsTitle>
          <EmissionsDateRange>
            {intl.formatMessage(
              {
                id: "carbon.emissions.graph.daterange",
                defaultMessage: "Jan {year} - Dec {year}"
              },
              { year }
            )}
          </EmissionsDateRange>
        </Flex>
        <EmissionsTotalWrapper>
          <EmissionsTotal>{formatNumber(total)} </EmissionsTotal>
          <EmissionsUnit>
            {intl.formatMessage({
              id: "carbon.emissions.units",
              defaultMessage: "kg CO2eq"
            })}{" "}
            {intl.formatMessage({
              id: "carbon.emissions.total"
            })}
          </EmissionsUnit>
          <Popover />
        </EmissionsTotalWrapper>
      </EmissionsHeader>
      {graphData.length > 0 ? (
        <>
          <CarbonEmissionsGraph chartData={graphData} />
          <EmissionsNote>
            {intl.formatMessage({
              id: "carbon.emissions.graph.regionexclusion"
            })}
          </EmissionsNote>
        </>
      ) : (
        <NoGraphDataMessage>
          {intl.formatMessage({
            id: "carbon.emissions.graph.nodata",
            defaultMessage: "No emissions data available for this period"
          })}
          <Popover />
        </NoGraphDataMessage>
      )}
    </>
  );
};

// Helper for formatting numbers
const formatNumber = (value: number | undefined) => {
  return value !== undefined ? value.toFixed(2) : "0.00";
};

const EmissionsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
`;

const EmissionsTitle = styled.h2`
  font-size: 15px;
  font-weight: 700;
  color: var(--mode-text-neutral-default);
  margin: 0;
`;

const EmissionsDateRange = styled.span`
  color: var(--mode-text-neutral-weakest);
  font-size: 14px;
  margin-left: 8px;
`;

const EmissionsTotalWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const EmissionsTotal = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: var(--mode-text-neutral-default);
`;

const EmissionsUnit = styled.span`
  color: var(--mode-text-neutral-weakest);
  font-size: 13px;
  margin-left: 8px;
`;

const EmissionsNote = styled.p`
  color: var(--mode-text-neutral-weakest);
  font-size: 13px;
  margin: 16px 0 0 0;
`;

const Flex = styled.div`
  display: flex;
  align-items: baseline;
`;

const NoGraphDataMessage = styled.div`
  height: ${CHART_CONFIG.dimensions.height}px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--mode-text-neutral-weakest);
  font-size: 16px;
  text-align: center;
`;
